export default __webpack_public_path__ + "static/media/portifa-mobile.a3612f8f.png";